import React from 'react';
import { withTranslation } from 'react-i18next';

class AchievementsDataProtection extends React.Component {
    render() {
        const { t } = this.props;
        const items = [
            { title: t('pages.dataProtection.achievements.item1.title'), description: t('pages.dataProtection.achievements.item1.description') },
            { title: t('pages.dataProtection.achievements.item2.title'), description: t('pages.dataProtection.achievements.item2.description') },
            { title: t('pages.dataProtection.achievements.item3.title'), description: t('pages.dataProtection.achievements.item3.description') },
            { title: t('pages.dataProtection.achievements.item4.title'), description: t('pages.dataProtection.achievements.item4.description') },
        ];
        return (
            <div className="dp-section dp-alt mobile-page-padding">
                <div className="container">
                    <div className="dp-head-center">
                        <h2 className="dp-title">{t('pages.dataProtection.achievements.heading')}</h2>
                        <div className="dp-rule" />
                    </div>
                    <div className="dp-grid2">
                        {items.map((item, i) => (
                            <div className="dp-item" key={i}>
                                <div className="dp-item-h">
                                    <span className="dp-item-num">{`0${i + 1}`}</span>
                                    <h4>{item.title}</h4>
                                </div>
                                <p>{item.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
};

export default withTranslation()(AchievementsDataProtection);
